export default "__VITE_ASSET__0tBklyXc__"